import { Skeleton } from '../../../Skeleton'
import { getEmailProfileSkeletonClassName } from '../../EmailProfile'

import * as styles from './EmailProfileMessageBodySkeleton.module.css'

function EmailProfileMessageBodySkeleton() {
  return (
    <div className={styles.EmailProfileMessageBodySkeleton}>
      <div className={styles.messageContainer}>
        {Array.from({ length: 8 }).map((_, index) => (
          <Skeleton
            className={getEmailProfileSkeletonClassName(
              styles.messageItem,
              styles[`messageItem${index}`]
            )}
            key={index}
          />
        ))}
      </div>
      <div className={styles.actions}>
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton
            className={getEmailProfileSkeletonClassName(
              styles[`action${index}`]
            )}
            key={index}
          />
        ))}
      </div>
    </div>
  )
}

export default EmailProfileMessageBodySkeleton
